import "./Observation.css";
import { useCallback, useState } from "react";
import { formatDate } from "../../../service/constants";

const Observation = (props) => {
  const [data, setData] = useState(props.getData());

  const [currentIdx, setcurrentIdx] = useState("");
  const [searchText, setSearchText] = useState("");
  // useEffect(() => {
  //   if (searchText === "") {
  //     // If searchText is empty, set data.objects to original data
  //     setData(props.getData());
  //     return;
  //   }

  //   // Filter data.objects based on searchText
  //   const originalData = props.getData();
  //   const filteredObjects = originalData?.objects?.filter((item) => {
  //     const codeTextMatch =
  //       item.resource?.code?.text
  //         ?.trim()
  //         .toLowerCase()
  //         .includes(searchText.trim().toLowerCase()) || false;

  //     const categoryTextMatch =
  //       item?.resource?.category?.[0]?.text
  //         ?.trim()
  //         .toLowerCase()
  //         .includes(searchText.trim().toLowerCase()) || false;

  //     return codeTextMatch || categoryTextMatch;
  //   });

  //   // Set filtered objects to data.objects
  //   setData({
  //     objects: filteredObjects,
  //   });
  // }, [props, searchText]);

  const handleChange = useCallback(
    (e) => {
      setSearchText(e.target.value);
      setcurrentIdx("");
      const originalData = props.getData();
      const filteredObjects = originalData?.objects?.filter((item) => {
        const codeTextMatch =
          item.resource?.code?.text
            ?.trim()
            .toLowerCase()
            .includes(e.target.value.trim().toLowerCase()) || false;

        const categoryTextMatch =
          item?.resource?.category?.[0]?.text
            ?.trim()
            .toLowerCase()
            .includes(e.target.value.trim().toLowerCase()) || false;

        return codeTextMatch || categoryTextMatch;
      });
      setData({ objects: filteredObjects });
    },
    [props]
  );

  return (
    <div className="observationContainerResource">
      <div className="search">
        <input
          type="text"
          value={searchText}
          onChange={handleChange}
          className="searchBox"
          placeholder="Search..."
        />
      </div>

      {data?.objects?.map((item, idx) => (
        <div
          className={`observationItem ${
            currentIdx === idx ? "active" : ""
          } cursor-pointer`}
          key={idx}
          onClick={() => {
            props.setResourceListData(item);
            setcurrentIdx(idx);
          }}
        >
          {item?.resource?.effectiveDateTime && (
            <span
              className={`observationDate ${
                idx === data?.objects?.length - 1 ? "lastRow" : ""
              }`}
            >
              {formatDate(item?.resource?.effectiveDateTime)}
            </span>
          )}
          <span
            className={`${
              idx === data?.objects?.length - 1 ? "lastRow" : ""
            } observationText`}
          >
            {item?.resource?.code?.text}{" "}
            {item?.resource?.category && item?.resource?.category[0]?.text}
          </span>
        </div>
      ))}
    </div>
  );
};

export default Observation;
